import styled from "@emotion/styled";
import bgImage from "../assets/bgImage.png";
const LeaveStyle = styled.div({
  position: "relative",
  background: `url(${bgImage})`,
  objectFit: "cover",
  maxWidth: "100vw",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",
  "& .reason": {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: 100,
    fontWeight: "500",
  },
  "& .Applied": {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: 100,
  },
  "& .ant-table-pagination.ant-pagination": {
    display: "none",
  },

  "& .ant-btn-primary": {
    borderColor: "#244DA0",
    backgroundColor: "#244DA0",
    borderRadius: "2px",
    color: "white",
    fontWeight: "500",
    float: "right",
  },
});
export default LeaveStyle;
